var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "未识别产品信息",
        visible: _vm.dialogVisible,
        width: "1200px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "data" },
            [
              _c(
                "virtual-scroll",
                {
                  attrs: {
                    data: _vm.segmentData,
                    "item-size": 62,
                    "key-prop": "id",
                  },
                  on: { change: (renderData) => (_vm.dataList = renderData) },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "loadmore-table",
                      attrs: {
                        stripe: "",
                        data: _vm.dataList,
                        height: "500px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          align: "center",
                          width: "55px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("el-checkbox", {
                                  staticClass: "checkBox",
                                  on: { change: _vm.handleSelectionChange },
                                  model: {
                                    value: row.isCheck,
                                    callback: function ($$v) {
                                      _vm.$set(row, "isCheck", $$v)
                                    },
                                    expression: "row.isCheck",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "nameCH",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input", {
                                    attrs: { size: "mini", clearable: "" },
                                    model: {
                                      value: row.nameCH,
                                      callback: function ($$v) {
                                        _vm.$set(row, "nameCH", $$v)
                                      },
                                      expression: "row.nameCH",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("中文品名"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "nameEN",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input", {
                                    attrs: { size: "mini", clearable: "" },
                                    model: {
                                      value: row.nameEN,
                                      callback: function ($$v) {
                                        _vm.$set(row, "nameEN", $$v)
                                      },
                                      expression: "row.nameEN",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("英文品名"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "hsCode",
                            align: "center",
                            width: "220",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-input",
                                    {
                                      style: {
                                        "--fill-color": row.existsHsCode
                                          ? "#f56c6c"
                                          : "#606266",
                                      },
                                      attrs: {
                                        size: "mini",
                                        clearable: "",
                                        placeholder: "请输入内容",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.rateBlur(row)
                                        },
                                      },
                                      model: {
                                        value: row.hsCode,
                                        callback: function ($$v) {
                                          _vm.$set(row, "hsCode", $$v)
                                        },
                                        expression: "row.hsCode",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          slot: "append",
                                          icon: "el-icon-search",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.searchTax(row)
                                          },
                                        },
                                        slot: "append",
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("美国税号"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "hsCode",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("p", [
                                    _vm._v("基础税率：" + _vm._s(row.baseRate)),
                                  ]),
                                  _c("p", [
                                    _vm._v("加征税率：" + _vm._s(row.addRate)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [_vm._v("税率")]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "material",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input", {
                                    attrs: { size: "mini", clearable: "" },
                                    model: {
                                      value: row.material,
                                      callback: function ($$v) {
                                        _vm.$set(row, "material", $$v)
                                      },
                                      expression: "row.material",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("材质"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "used",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input", {
                                    attrs: { size: "mini", clearable: "" },
                                    model: {
                                      value: row.used,
                                      callback: function ($$v) {
                                        _vm.$set(row, "used", $$v)
                                      },
                                      expression: "row.used",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("用途"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "priceMin",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input-number", {
                                    attrs: {
                                      size: "mini",
                                      "controls-position": "right",
                                      min: 0.01,
                                      precision: 2,
                                      step: 1,
                                    },
                                    model: {
                                      value: row.priceMin,
                                      callback: function ($$v) {
                                        _vm.$set(row, "priceMin", $$v)
                                      },
                                      expression: "row.priceMin",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("单价最小值"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "priceMax",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input-number", {
                                    attrs: {
                                      size: "mini",
                                      "controls-position": "right",
                                      min: row.priceMin || 0.01,
                                      precision: 2,
                                      step: 1,
                                    },
                                    model: {
                                      value: row.priceMax,
                                      callback: function ($$v) {
                                        _vm.$set(row, "priceMax", $$v)
                                      },
                                      expression: "row.priceMax",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("单价最大值"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "weightMin",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input-number", {
                                    attrs: {
                                      size: "mini",
                                      "controls-position": "right",
                                      min: 0.01,
                                      precision: 2,
                                      step: 1,
                                    },
                                    model: {
                                      value: row.weightMin,
                                      callback: function ($$v) {
                                        _vm.$set(row, "weightMin", $$v)
                                      },
                                      expression: "row.weightMin",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("重量最小值"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "priceMax",
                            align: "center",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input-number", {
                                    attrs: {
                                      size: "mini",
                                      "controls-position": "right",
                                      min: row.weightMin || 0.01,
                                      precision: 2,
                                      step: 1,
                                    },
                                    model: {
                                      value: row.weightMax,
                                      callback: function ($$v) {
                                        _vm.$set(row, "weightMax", $$v)
                                      },
                                      expression: "row.weightMax",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v("重量最大值"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: {
                          label: "备注",
                          prop: "remark",
                          align: "center",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("el-input", {
                                  attrs: { size: "mini", clearable: "" },
                                  model: {
                                    value: row.remark,
                                    callback: function ($$v) {
                                      _vm.$set(row, "remark", $$v)
                                    },
                                    expression: "row.remark",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { attrs: { slot: "append" }, slot: "append" },
                        [
                          _c(
                            "InfiniteLoading",
                            {
                              attrs: {
                                forceUseInfiniteWrapper:
                                  ".loadmore-table .el-table__body-wrapper",
                              },
                              on: { infinite: _vm.loadMore },
                            },
                            [
                              _c("span", {
                                attrs: { slot: "no-more" },
                                slot: "no-more",
                              }),
                              _c("span", {
                                attrs: { slot: "no-result" },
                                slot: "no-result",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("p", { staticClass: "selection" }, [
            _vm._v("已选择 " + _vm._s(_vm.selections.length) + " 项"),
          ]),
        ]
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v(" 确 定 ")]
          ),
        ]
      ),
      _c("TaxDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
          ok: _vm.ok2,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }